import React from "react";
import Button from "../Button/Button.jsx";

// "Delete Selected (N)" action shared by every table with checkbox
// bulk-select. Always rendered (not hidden at 0 - Requirement 6), just
// disabled until at least one row is checked, so its presence doesn't jump
// the layout around as the selection changes. Right-aligned (justify-end)
// and styled "danger" (red) per the user's explicit request, to visually
// signal it's a destructive action rather than blending in with Continue.
const BulkDeleteBar = ({ count, onDelete, loading = false, className = "" }) => (
  <div className={["flex items-center justify-end gap-2 mb-2.5", className].join(" ")}>
    <Button
      variant="danger"
      size="sm"
      className="!text-xs !px-3 !py-1.5"
      onClick={onDelete}
      disabled={count === 0 || loading}
    >
      {loading ? `Deleting ${count} record${count === 1 ? "" : "s"}…` : `Delete Selected${count ? ` (${count})` : ""}`}
    </Button>
  </div>
);

export default BulkDeleteBar;
